module.exports = __webpack_public_path__ + "static/img/sj@2x.c1e7824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj@2x.png
// module id = omB0
// module chunks = 1